"use client";

import { SessionProvider } from "next-auth/react";

export default function ClientProviders({ children }) {
  return (
    <SessionProvider refetchOnWindowFocus={false}>{children}</SessionProvider>
  );
}
